<template><section><h3>基于实时位置数据的传染病密接个体识别系统</h3>
<h4>背景介绍：</h4>
<p>在新冠等传染病防治中，通过分析个体在不同时间所处的位置信息，可以得知个体间是否曾经有过一段时间的密切接触。这些密切接触信息，可以有效的帮助我们识别可能的传染链条，从而控制传染病的蔓延。</p>
<p>一个密切接触需要满足两个条件：首先，两个个体只在在同一时刻空间上的位置需要小于某一个阈值，亦即在空间上临近；其次，两个个体需要空间上连续临近时间超过某个阈值。例如，我们设置最大接触距离为2米，最小接触时间为15秒，如果两人连续15秒以上保持接触距离都小于2米，我们认为他们是一对有效的密切接触。</p>
<p>除了密接之外，我们还可以通过密接寻找次密接。例如，A与B到T1时间完成了一次有效接触，B与C在T2时间完成了一次有效接触，并且T2&gt;T1且T2-T1小于某一个阈值，例如在新冠中我们规定14天，则我们认为A与C通过B进行了次密接。</p>
<p><img src="https://img.remit.ee/api/file/BQACAgUAAyEGAASHRsPbAAL8PGi377aOyuySwA12xZ9qFBUCgN9hAAISGgACc5zBVQwf1U5A9yIINgQ.png" alt="fig1.png"></p>
<h4>项目要求：</h4>
<ol>
<li>项目将提供随机轨迹生成器，生成特定数量个体在特定时间内的轨迹数据</li>
<li>根据每秒钟生成的轨迹数据，通过分布式数据处理框架完成密接个体的识别
<ul>
<li>a) 中级目标：利用Spark等分布式批处理架构从已经收集到的轨迹数据中识别出空间密接个体。</li>
<li>b) 高级目标：利用Flink等流式数据处理架构从实时生成的轨迹数据中识别出空间密接个体。</li>
</ul>
</li>
<li>获取到的密接信息应该包括两个体密接的时间（区间）、空间（密接发生的范围）及密接发生的个体。</li>
<li>将获取到的密接信息通过合理的数据结构或数据存储系统进行存储，以供后续进行密接和次密接个体的查询</li>
<li>通过图形界面将数据的导入、密接和次密接个体的查询、轨迹数据及密接次密接数据在地图上的展示等。</li>
</ol>
</section></template><script>export default {components:{}}</script>